import React from 'react'
import { Card } from 'react-bootstrap'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { isMobile } from 'react-device-detect';

const IndustrialModeling = (props) => {
    const responsive = {
        desktop: {
          breakpoint: { max: 5000, min: 1024 },
          items: 1,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        }
      };
  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
        <Card.Body>
            <Card.Title className='industrial-modeling-title'> 産業用モデリング </Card.Title>
            <Card.Text className='industrial-modeling-text text-left'>
            自動化、IoT（Internet of Things）データ、相互接続システム、AIの適用の増加に伴い、製造業や産業施設における3Dモデリング採用の最前線は、インダストリー4.0になりつつあります。組立ラインや工場全体のデジタルツインは、リアルタイムで施設のバーチャル空間にデータを表示することができます。また、これらの大規模な3Dモデルは、アニメーションのような形で作業者の訓練や評価に利用されたり、没入型のVRトレーニングに利用されたりします。
            </Card.Text>
            <Card.Subtitle className="industrial-modeling-subtitle py-4"> 工場ロボットのアニメーション </Card.Subtitle>
                <div className='industrial-modeling-section'>
                    <video className='industrial-modeling-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                        <source src={"/assets/industrial/video/ARM_Factory_Render_v001.mp4"} type="video/mp4"/>
                    </video>
                </div>
        </Card.Body>
        </Card>
        <Card className='no-border rounded-0 industrial-modeling-bottom-section py-5 container'>
            <Card.Body>
                <Card.Text className='industrial-modeling-text text-left'>
                デジタルツインは、グラフィック、センサー、データなどを使って、企業の機械、システム、設備、資産をデジタル空間で視覚的に表現するものです。既存のCAD図面や、必要に応じてゼロからデジタルツイン用のグラフィックモデルを構築することができます。
                <br />
                <br />
                </Card.Text>
                    <Carousel
                     responsive={responsive}
                     autoPlay={false}
                     arrows={isMobile ? false : true }
                     centerMode={ isMobile ? false : true }
                     slidesToSlide={1}
                     infinite={true}
                     showDots={true}
                    //  keyBoardControl={true}
                     renderDotsOutside={true}
                     draggable={false}
                     autoPlaySpeed={3000}
                    >
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/industrial/images/ind002.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/industrial/images/ind003.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/industrial/images/ind004.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/industrial/images/ind005.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/industrial/images/ind001.jpg"} alt="" />
                        </div>
                    </Carousel>
            </Card.Body>
        </Card>
    </>
  )
}

export default IndustrialModeling
